export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover object-top"
          aria-label="People happily exchanging items in a community setting"
          poster="https://public.readdy.ai/ai/img_res/10df9bd752c5866a73f96cef4776faaa.jpg"
        >
          <source src="https://cdn.pixabay.com/video/2023/08/15/175634-855068896_large.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-teal-900/60 via-teal-800/40 to-teal-900/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-2 h-2 bg-teal-400 rounded-full"></div>
          <span className="text-teal-100 text-xs font-semibold tracking-widest uppercase">Community-Driven Platform</span>
        </div>

        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
          Swap What You<br />
          <span className="font-serif italic">Don't Need</span><br />
          For What You Love
        </h1>

        <p className="text-xl text-gray-200 mb-10 max-w-2xl mx-auto">
          Turn waste into value. Build community through sustainable exchange.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <button className="bg-teal-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-teal-700 transition-all flex items-center gap-2 whitespace-nowrap shadow-lg hover:shadow-xl">
            Start Swapping
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
          <button className="border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-teal-900 transition-all flex items-center gap-2 whitespace-nowrap">
            <i className="ri-play-circle-line text-xl"></i>
            Watch How It Works
          </button>
        </div>
      </div>
    </section>
  );
}
